import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import {
  FormCheck, If, Save, FormDatePicker,
  SummingUp,
  appActions,
  PrevNextButton,
  AutomatischSpeichernModal,
  useUpdateAndValidateOnChange,
  useUpdateAndValidateDateOnChange,
  useUpdateByNameAndValidateOnChange, istEnumAuswahl, EnumVorgangsart, EnumActions,
} from 'ion-lib';
import { useDispatch, useSelector } from 'react-redux';
import { getBannerFileName, istHausrat } from '../../helper';
import SummingupWarenkorb from '../../components/SummingupWarenkorb';

const Unterschrift = () => {
  const dispatch = useDispatch();
  const unterschrieben = useSelector((state) => state.daten.unterschrieben);
  const unterschriebenAm = useSelector((state) => state.daten.unterschriebenAm);
  const vorgangsart = useSelector((state) => state.daten.vorgangsart);
  const vsnrHausrat = useSelector((state) => state.daten.vsnrHausrat);
  const vsnrGlas = useSelector((state) => state.daten.vsnrGlas);
  const vsnrHausratAltFuerNeuordnung = useSelector((state) => state.daten.vsnrHausratAltFuerNeuordnung);
  const vsnrHausratGlasAltFuerNeuordnung = useSelector((state) => state.daten.vsnrHausratGlasAltFuerNeuordnung);
  const updateAndValidateOnChange = useUpdateAndValidateOnChange(0);
  const updateValidateDateOnChange = useUpdateAndValidateDateOnChange();
  const validateOnChangeByName = useUpdateByNameAndValidateOnChange();

  const handleNextClick = () => {
    dispatch(appActions.serverValidationRequest(EnumActions.VALIDIERE, [
      'unterschrieben',
      'unterschriebenAm',
    ], () => {
      dispatch(appActions.request('beantragen', () => {
        dispatch(appActions.request('beendeTarifrechner', () => {
          window.OSPlusNeo.reportSuccess();
        }, () => {
          window.OSPlusNeo.reportError();
        }));
      }));
    }));
  };

  const speichern = (e) => {
    e?.preventDefault();
    dispatch(appActions.request('speichereAngebot', () => {
      window.OSPlusNeo.reportSuccess();
    }, () => {
      window.OSPlusNeo.reportError();
    }));
  };

  return (
    <Row>
      <Col>
        <div className="w-md spkpanel p-3 mb-3">
          <h2 className="h4 headline mb-5">
            Sind alle Unterlagen für den Antrag zur VSNR
            {' '}
            {vsnrHausrat.relevant && vsnrHausrat.value}
            {vsnrHausratAltFuerNeuordnung.relevant && vsnrHausratAltFuerNeuordnung.value}
            {istHausrat() && (vsnrGlas.relevant || vsnrHausratGlasAltFuerNeuordnung.relevant) ? ' und VSNR ' : ''}
            {vsnrGlas.relevant && vsnrGlas.value}
            {vsnrHausratGlasAltFuerNeuordnung.relevant && vsnrHausratGlasAltFuerNeuordnung.value}
            {' '}
            vorhanden?
          </h2>
          <If predicate={unterschrieben.relevant}>
            <FormCheck
              {...unterschrieben}
              onChange={updateAndValidateOnChange}
              name="daten.unterschrieben.value"
              labelClassName="sp-w-100"
              inline
            />
          </If>
          {istEnumAuswahl(vorgangsart, EnumVorgangsart.NEUVERTRAG) && (
          <p className="mt-5">
            <Button
              variant="link"
              className="link"
              onClick={speichern}
            >
              <Save />
              {' '}
              Zwischenspeichern und Antrag später freigeben.
            </Button>
          </p>
          )}
          <If predicate={unterschriebenAm.relevant}>
            <FormDatePicker
              {...unterschriebenAm}
              className="mt-5"
              onInputChange={updateValidateDateOnChange}
              onChange={validateOnChangeByName}
              label="Der Antrag wurde vom Kunden am folgenden Tag unterschrieben"
              name="daten.unterschriebenAm.value"
            />
          </If>
        </div>

        <AutomatischSpeichernModal speichern={speichern} />

        <Row>
          <Col>
            <PrevNextButton
              className="d-md-none oev-show spk-show"
              nextProps={{
                text: 'Freigeben',
                disabled: !unterschrieben.value,
              }}
              onNextClick={handleNextClick}
            />
          </Col>
        </Row>
      </Col>

      <SummingUp bannerImg={getBannerFileName}>
        <SummingupWarenkorb
          nolink
        />
      </SummingUp>
    </Row>
  );
};

export default Unterschrift;
